
import React,{useState,useEffect, useRef} from 'react'
import { Link } from 'react-router-dom';
import "./Sidebar.css"
import  config  from '../../env.json';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from '../../app/slice/sideBarSlice';
import { useTranslation, initReactI18next } from "react-i18next";
import { useNavigate} from 'react-router-dom';
import { getUserPermissions } from '../../apis/userPermissionApi/userPermissionApi';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'




function Sidebar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeTab = useSelector((state: any) =>state.sideBar.active);
  const [menuItems,setMenuItems] = useState<any[]>([]);
  const [menuList,setMenuList] = useState<any[]>([]);
  const [activeClass,setActiveClass] = useState('');
  const EmpId=useSelector((state:any)=>state.authApiSlice.Id);
  const EnvId=useSelector((state:any)=>state.userPermisssion.env);
  const ActiveClient=useSelector((state:any)=>state.clientDetails.activeClient);

  const menuData = [
    {
      "PermissionsId": 1004,
      "Permissions_Nm": "Home",
      "Display_Nm": "Home",
      "Display_Or": 1,
      "ClassNameForUI": "fas fa-house-chimney"
  },
  {
      "PermissionsId": 1003,
      "Permissions_Nm": "Flow Builder",
      "Display_Nm": "Flow Builder",
      "Display_Or": 2,
      "ClassNameForUI": "fas fa-circle-nodes"
  },
    {
      "PermissionsId": 1091,
      "Permissions_Nm": "tenants",
      "Display_Nm": "Create Tenant",
      "Display_Or": 8,
      "ClassNameForUI": "fas fa-gears"
  },
    {
      PermissionsId: 1008,
      Permissions_Nm: "Menu Configurations",
      Display_Nm: "Menu Configurations",
      Display_Or: 8,
      ClassNameForUI: "fas fa-gears",
    },
    {
      PermissionsId: 1009,
      Permissions_Nm: "Keyvault Configurations",
      Display_Nm: "Keyvault Configurations",
      Display_Or: 9,
      ClassNameForUI: "fas fa-key",
    },
    {
      PermissionsId: 1010,
      Permissions_Nm: "Data Mapping",
      Display_Nm: "Data Mapping",
      Display_Or: 10,
      ClassNameForUI: "fas fa-database",
    },
    {
      PermissionsId: 1111,
      Permissions_Nm: "templates",
      Display_Nm: "Templates",
      Display_Or: 15,
      ClassNameForUI: "fa-solid fa-file-pen",
    },
    {
      PermissionsId: 1011,
      Permissions_Nm: "Roles And Permissions",
      Display_Nm: "Roles & Permissions",
      Display_Or: 10,
      ClassNameForUI: "fas fa-user-gear",
    },
    {
      PermissionsId: 1100,
      Permissions_Nm: "Deployment Status",
      Display_Nm: "Deployment Status",
      Display_Or: 11,
      ClassNameForUI: "fas fa-user-gear",
    },
    {
      PermissionsId: 1012,
      Permissions_Nm: "Master Keys",
      Display_Nm: "Master Keys",
      Display_Or: 12,
      ClassNameForUI: "fas fa-user-shield",
    },
    {
      PermissionsId: 1090,
      Permissions_Nm: "Releases",
      Display_Nm: "Releases",
      Display_Or: 13,
      ClassNameForUI: "fas fa-user-shield",
    },
    {
      PermissionsId: 0,
      Permissions_Nm: "Keyvaults",
      Display_Nm: "Keyvaults",
      Display_Or: 14,
      ClassNameForUI: "fas fa-user-shield",
    },
    //   {
    //     "PermissionsId": 1012,
    //     "Permissions_Nm": "Automation",
    //     "Display_Nm": "Automation",
    //     "Display_Or": 12,
    //     "ClassNameForUI": "fas fa-share-nodes"
    // },
    //   {
    //     "PermissionsId": 1005,
    //     "Permissions_Nm": "Create Client",
    //     "Display_Nm": "Create Env",
    //     "Display_Or": 3,
    //     "ClassNameForUI": "fas fa-circle-plus"
    // },
    // {
    //     "PermissionsId": 1006,
    //     "Permissions_Nm": "Configure",
    //     "Display_Nm": "Configure Env",
    //     "Display_Or": 4,
    //     "ClassNameForUI": "fas fa-gears"
    // },
    // {
    //     "PermissionsId": 1007,
    //     "Permissions_Nm": "Maintain Data",
    //     "Display_Nm": "Maintain Data",
    //     "Display_Or": 5,
    //     "ClassNameForUI": "fas fa-database"

    // },
    // {
    //     "PermissionsId": 1007,
    //     "Permissions_Nm": "sms",
    //     "Display_Nm": "Maintain Data",
    //     "Display_Or": 5,
    //     "ClassNameForUI": "fas fa-database"
    // }
  ];


  const getMenuItems = async()=>{
    console.log("Env_Id::--",EnvId)

    let y=  menuData;
    setMenuList(y);
    if(!activeTab){
      handleMenuItemClick(y[0]);
    }else
    {
      setActiveClass(activeTab);
    }

    let payload:any={
      "Env_Id":ActiveClient.Env_Data[0].Env_Id,
      "Employee_Id":EmpId
  };

  const menuItems =  getUserPermissions(payload,(response:any) => {
    console.log("menuItems::--",response)
      
      if(response){
        
      if(response.data.message === 'No Menu Options to display'){
        console.log('No Data')
      navigate('/error')
      
      }}
      // response.data.sort((a: any, b: any) => parseFloat(a.Display_Or) - parseFloat(b.Display_Or));


      // let y=  response.data.filter((d:any) => d.Display_Or >= 0);

      let y=  response.filter((d:any) => d.Display_Or >= 0);
      // let y=  menuData;
     

      // setMenuList(y);
      // 
      // if(!activeTab){
      //   handleMenuItemClick(y[0]);
      // }else
      // {
      //   setActiveClass(activeTab);
      // }
      
    //  setDefaultMenuItemSelected(response.data[0]);
    })
    // .catch((error:any) => {
    //     console.error('There was an error!', error);
    // });


    // let menuData=[
    //   {
    //     "PermissionsId": 1004,
    //     "Permissions_Nm": "sms",
    //     "Display_Nm": "Home",
    //     "Display_Or": 1,
    //     "ClassNameForUI": "fas fa-house-chimney"
    // },
    // {
    //     "PermissionsId": 1003,
    //     "Permissions_Nm": "contacts",
    //     "Display_Nm": "Flow Builder",
    //     "Display_Or": 2,
    //     "ClassNameForUI": "fas fa-circle-nodes"
    // },
    //   {
    //     "PermissionsId": 1005,
    //     "Permissions_Nm": "sms",
    //     "Display_Nm": "Create Env",
    //     "Display_Or": 3,
    //     "ClassNameForUI": "fas fa-circle-plus"
    // },
    // {
    //     "PermissionsId": 1006,
    //     "Permissions_Nm": "contacts",
    //     "Display_Nm": "Configure Env",
    //     "Display_Or": 4,
    //     "ClassNameForUI": "fas fa-gears"
    // },
    // {
    //     "PermissionsId": 1007,
    //     "Permissions_Nm": "contacts",
    //     "Display_Nm": "Maintain Data",
    //     "Display_Or": 5,
    //     "ClassNameForUI": "fas fa-database"
    // }
    // ];



  // // let y=  response.data.filter((d:any) => d.Display_Or >= 0);
  // let y=  menuData.filter((d:any) => d.Display_Or >= 0);
 

  // setMenuItems(y);
  // handleMenuItemClick(y[0]);
  // 
  // if(!activeTab){
  //   handleMenuItemClick(y[0]);
  // }else
  // {
  //   setActiveClass(activeTab);
  // }

    
}

const getIcon=(item:any)=>{
  let tabname:any=item.Permissions_Nm;
  const getItem :any= menuData.find((i) => i.Permissions_Nm.toLowerCase() == tabname.toLowerCase());
  
  return getItem.ClassNameForUI;
}


const setDefaultMenuItemSelected =(menuItem: any)=>{
      setActiveClass(menuItem.PermissionsId);
}
// useEffect(() => {
//   console.log(activeTab)
// }, [activeTab])

useEffect(() => {
  // console.log("activeTab:",activeTab);
  let y=  menuData;
  setMenuList(y);
}, [])
  
  const handleMenuItemClick =(item: any) =>{
    setActiveClass(item.PermissionsId);
    
    dispatch(setActiveTab(item.PermissionsId));
  }
  const { t } = useTranslation();
  return (
    <div className="sidebar-container notMobile">

        <div className="zing-logo-div">
          <div className='logo-img'>

          <img src={config.REACT_APP_LOGO} alt="Zing Logo" />

          </div>
        </div>

        <div className="menu-btn-div">
            <ul>
              
              {
                  menuList?.map(items => {
                    return (<>
                   
                        <Link key={ items.PermissionsId }
                            className={activeClass === items.PermissionsId ? 'active':'' }
                            onClick={(e)=>{ handleMenuItemClick(items)                            
                             }} 
                            to={"/"+ items.Permissions_Nm.replace(/ /g,"")}>

                              {/* <i className={items.ClassNameForUI}></i> */}
                              <FontAwesomeIcon icon={items.ClassNameForUI} />
                              {/* <FontAwesomeIcon icon={getIcon(items)} /> */}
                              <h3>
                                {t(items.Display_Nm)}
                              </h3>
                              
                      </Link> 
                            
                     </>
                    )
                  })
              }
                
            </ul>
        </div>

  </div>
  )
}

export default Sidebar